import React from 'react'
import whyKeratinBanner from "./../../../../../Images/Blog/Why_Keratin_Hair/Banner.png";

const WhyKeratinImg = () => {
  return (
    <div className="blogImg-content">
      <img src={whyKeratinBanner} alt="whyKeratinBanner" loading="lazy" />
    </div>
  )
}

export default WhyKeratinImg
